import { Box, Flex } from '@chakra-ui/react';
import React, { useState } from 'react';
import Dropzone from 'react-dropzone';

import { ExportIcon } from 'Asset/icon';
import { TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import { Condition } from 'Component/others';
import text from 'Const/component/dropZone';

import styles from './styles.module.css';

const UploadFile = ({
  onDrop,
  accept = { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
  maxFiles = 1,
  maxSize,
  titleText = 'Klik untuk upload atau drag and drop file',
  textError = text?.errorMaxSizeAttachment,
  descText = 'Format .XLSX (maks 1 MB)',
  ...props
}) => {
  const [errorText, setErrorText] = useState('');

  const handleUpload = (files) => onDrop(files);

  const handleError = (filesError) => {
    filesError?.forEach(({ errors }) => {
      const errorType = errors[0]?.code;
      const errorMessage = errors[0]?.message;

      switch (errorType) {
        case 'file-too-large':
          setErrorText(textError);
          break;
        default:
          setErrorText(errorMessage);
          break;
      }
    });
  };

  return (
    <Box>
      <Dropzone onDrop={handleUpload} accept={accept} maxSize={maxSize} maxFiles={maxFiles} onDropRejected={handleError}>
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <Box
              {...getRootProps({
                className: `${styles['dropzone__container']} 
                            ${isDragActive ? styles['dropzone__container--active'] : ''} 
                            ${errorText ? styles['dropzone__container--error'] : ''}`,
              })}
            >
              <input {...getInputProps()} data-testid={props?.['data-testid'] || ''} />
              <Flex flexDirection={'column'} alignItems={'center'} gap={'12px'}>
                <ExportIcon />
                <Flex flexDirection={'column'} alignItems={'center'} gap={'4px'} style={{ margin: '0 4px' }}>
                  <TextSemiBold className={styles['dropzone__text--title']}>{titleText}</TextSemiBold>
                  <TextRegular className={styles['dropzone__text--desc']}>{descText}</TextRegular>
                </Flex>
              </Flex>
            </Box>
          );
        }}
      </Dropzone>

      <Condition statement={errorText !== ''}>
        <TextMedium className={styles['dropzone__error-text']}>{errorText}</TextMedium>
      </Condition>
    </Box>
  );
};

export default UploadFile;
